import { Children, isValidElement, ReactNode } from "react";
import Heading from "../ui/Heading/Heading";
import SaveControls from "./Slots/Buttons";
import FixedArea from "./Slots/FixedArea";

const ScrollArea = ({ children }: { children: ReactNode }) => {
    const all = Children.toArray(children);

    let headingEl: ReactNode = null;
    let fixedArea: ReactNode = null;
    const saveControlsEls: ReactNode[] = [];
    const rest: ReactNode[] = [];

    for (const child of all) {
        if (!headingEl && isValidElement(child) && child.type === Heading) {
            headingEl = child;
        }
        else if (isValidElement(child) && child.type === FixedArea) {
            fixedArea = child;
        }
        else if (isValidElement(child) && child.type === SaveControls) {
            saveControlsEls.push(child);
        }
        else {
            rest.push(child);
        }
    }

    return (
        <div className="flex flex-col h-full min-h-0">
            {headingEl}
            {fixedArea}

            <div className="flex-1 min-h-0 pr-[2px]">
                <div className="h-full overflow-auto custom-scroll [scrollbar-gutter:stable_both-edges]">
                    {rest}
                </div>
            </div>

            {saveControlsEls.length > 0 && (
                <div className="shrink-0 w-full flex flex-col gap-3 p-6">
                    {saveControlsEls}
                </div>
            )}
        </div>
    )
};

export default ScrollArea;
